import React, { useState, useEffect } from 'react';
import LockOpenIcon from '@mui/icons-material/LockOpen';
import { CollapseCard } from '@totalsoft/rocket-ui';
import { UserRightItemComponent } from './UserRightItemComponent';
import { useListBrowserFunctions } from 'utils/hooks/useListBrowserFunctions';
import { useApolloFetching } from '@ts-private/list-browser-apollo-extensions';
import ListBrowser, { useListBrowserUtils } from '@ts-private/list-browser';
import { useTranslation } from 'react-i18next';
import { store, fetchOptions } from "../../store";
const UserRightsListcontainer = () => {

  const [t] = useTranslation();
  useApolloFetching(store, fetchOptions);
  const { updateFilter } = useListBrowserUtils(store);
  const { textResolver } = useListBrowserFunctions();

  const [expanded, setExpanded] = useState(false);

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  useEffect(() => {
    return () => {
      updateFilter('search')(null);
    }
  }, [updateFilter])

  return (
    <CollapseCard
      icon={LockOpenIcon}
      title={t('User.UserProfile.UserRights.Title')}
      expanded={expanded}
      onToggle={toggleExpanded}
      toggleOnHeaderClick
    >
      <ListBrowser store={store} ItemComponent={UserRightItemComponent} textResolver={textResolver} styles={{ container: { gap: 0 } }} />
    </CollapseCard>
  )
}

export default UserRightsListcontainer;
